export const SITE = {
  name: "Wellness Radiance Nutrition",
  founder: "Sony Mathew",
  founderKg: 27.4,
  phoneDisplay: "94468 69944",
  phoneTel: "+919446869944",
  whatsapp: "919446869944",
  email: "hello@wellnessradiancenutrition.com",
  hours: "All days · 6.30–11 AM and 5–8.30 PM",
  street: "Rohini Building, 285/A",
  locality: "Kazhakootam",
  cityName: "Thiruvananthapuram",
  region: "Kerala",
  postalCode: "695582",
  city: "Kazhakootam, Thiruvananthapuram",
  online: "Online consultations available",
  googleReviewsUrl: "",
  url: typeof window !== "undefined" ? window.location.origin : "",
  price: "₹7,500",
  days: 120,
  disclaimer: "Results vary. Individual results will differ.",
  coachLine: "Wellness coach, not dietitian.",
};

export const waLink = (msg = "Hi Sony, I'd like to book my free 20-minute consultation.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const PROGRAMME_PATH = "/healthy-active-lifestyle-programme";

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programme", to: PROGRAMME_PATH },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Success Stories", to: "/success-stories" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const HERO_FEATURES = [
  { icon: "salad", title: "Real Food", text: "Practical guidance" },
  { icon: "zap", title: "More Energy", text: "For everyday life" },
  { icon: "sprout", title: "Lasting Change", text: "Support that stays" },
  { icon: "heart", title: "Personalised", text: "Support for you" },
  { icon: "award", title: "Real Life", text: "Results" },
];

export const SONY_QUOTE = "Wellness is not about perfection. It's about consistent, mindful choices that add up to a better you.";
export const PHILOSOPHY = "Wellness is not about quick fixes. It's about creating balance, building healthy habits and becoming the best version of yourself, one day at a time.";

export const ABOUT_FEATURES = [
  { icon: "salad", title: "Real Food", text: "Simple, practical nutrition that fits your life." },
  { icon: "repeat", title: "Sustainable Habits", text: "Small changes that create big results." },
  { icon: "heart", title: "Personal Support", text: "Guidance, accountability and motivation every step." },
  { icon: "trend", title: "Lasting Transformation", text: "Build a healthier lifestyle that lasts." },
];

export const VALUES = [
  { icon: "salad", title: "Practical", text: "Real food, real life solutions." },
  { icon: "users", title: "Personalised", text: "Plans that fit you." },
  { icon: "heart", title: "Supportive", text: "Guidance every step of the way." },
  { icon: "sprout", title: "Sustainable", text: "Habits that last a lifetime." },
];

export const PILLARS = [
  { key: "nourish", num: "01", title: "Nourish", line: "Real meals from the kitchen you already have. No crash diets, no strange shopping lists.", image: "/images/greens.jpg", alt: "Fresh salad greens and vegetables on a plate" },
  { key: "energise", num: "02", title: "Energise", line: "Steadier energy through better sleep, gentle movement and meals that keep you going till evening.", image: "/images/walk.jpg", alt: "Morning walk on a green tree-lined path" },
  { key: "transform", num: "03", title: "Transform", line: "120 days of coached repetition, until the healthy choice is simply the normal one.", image: "/images/active.jpg", alt: "Person stretching outdoors in soft morning light" },
];

export const PHASES = [
  { num: "1", title: "Foundation", days: "Days 1–30", points: ["Understand your body and habits", "Build healthy eating patterns", "Improve hydration and sleep"] },
  { num: "2", title: "Build Momentum", days: "Days 31–60", points: ["Create sustainable routines", "Boost everyday energy", "Strengthen mindful eating"] },
  { num: "3", title: "Deepen Progress", days: "Days 61–90", points: ["Work through plateaus", "Strengthen consistency", "Build confidence and discipline"] },
  { num: "4", title: "A Healthier You", days: "Days 91–120", points: ["Lock in lifelong habits", "Feel more energetic and confident", "Celebrate your transformation"] },
];

export const STEPS = [
  { icon: "phone", num: "1", title: "Free Consultation", text: "We understand your goals, lifestyle and challenges." },
  { icon: "clipboard", num: "2", title: "Personalised Plan", text: "Get a simple, practical plan that fits your life." },
  { icon: "chat", num: "3", title: "Ongoing Coaching", text: "Regular check-ins, guidance and motivation." },
  { icon: "trend", num: "4", title: "Sustainable Results", text: "Build habits that last and enjoy lasting wellness." },
];

export const EXTRAS = ["Flexible, realistic guidance", "Practical nutrition and lifestyle tips", "Accountability and motivation", "Support even after 120 days"];

export const WHY = [
  { title: "A coach who has lived it", text: `Sony lost ${SITE.founderKg} kg himself. He knows the hard days because he has had them.` },
  { title: "Accountability, not a diet chart", text: "Most plans fail on day nine, not day one. Our coaching is built for the ordinary days in between." },
  { title: "Food you already eat", text: "Your plan works with your home kitchen and family meals instead of fighting against them." },
  { title: "Honest by design", text: "Wellness coach, not dietitian. For medical conditions we offer nutrition support alongside your doctor's treatment." },
];

export type Audience = {
  slug: string;
  title: string;
  short: string;
  pillar: string;
  image: string;
  alt: string;
  medical: boolean;
  intro: string;
  forYou: string[];
  support: string[];
};

export const AUDIENCES: Audience[] = [
  {
    slug: "weight-loss-programme",
    title: "Weight loss coaching",
    short: "Steady, sustainable fat loss built on everyday meals, not willpower.",
    pillar: "Transform",
    image: "/images/meal.jpg",
    alt: "Balanced nourishing meal bowl with vegetables and protein",
    medical: false,
    intro: "If you've lost weight before and watched it come back, the plan wasn't the problem. Consistency was. We coach the consistency.",
    forYou: ["You've tried diets that worked for a few weeks", "You want a realistic pace, not a crash", "You'd like someone to keep you on track"],
    support: ["Portion and plate guidance using your home food", "Realistic pace: around 4–6 kg in the first month for many people (results vary)", "Weekly progress reviews and plan adjustments"],
  },
  {
    slug: "pcos-nutrition-support",
    title: "PCOS / PCOD nutrition support",
    short: "Nutrition and lifestyle support alongside your doctor's treatment.",
    pillar: "Nourish",
    image: "/images/greens.jpg",
    alt: "Fresh green salad with seeds and olive oil",
    medical: true,
    intro: "Living with PCOS or PCOD can make weight and energy feel harder to manage. We focus on the daily habits you can control, alongside the care your doctor provides.",
    forYou: ["You've been diagnosed with PCOS or PCOD", "You want structure around meals and routine", "You're working with a doctor and want lifestyle support"],
    support: ["Balanced, regular meals built around your routine", "Movement and sleep habits that feel doable", "Coaching that complements, never replaces, medical care"],
  },
  {
    slug: "thyroid-nutrition-support",
    title: "Thyroid nutrition support",
    short: "Everyday nutrition habits that sit comfortably with your doctor's plan.",
    pillar: "Energise",
    image: "/images/smoothie.jpg",
    alt: "Fresh green smoothie in a glass",
    medical: true,
    intro: "When energy dips and progress feels slow, small daily habits matter more. We coach those habits, alongside your doctor's treatment.",
    forYou: ["You manage a thyroid condition with your doctor", "Low energy makes routines hard to keep", "You want gentle, sustainable change"],
    support: ["Meal rhythm and nourishing food choices", "Energy-friendly routines for sleep and movement", "Supportive check-ins that keep you consistent"],
  },
  {
    slug: "diabetes-lifestyle-support",
    title: "Diabetes lifestyle support",
    short: "Practical meal and routine coaching alongside your doctor's treatment.",
    pillar: "Nourish",
    image: "/images/chopping.jpg",
    alt: "Hands chopping fresh vegetables on a wooden board",
    medical: true,
    intro: "Knowing what to eat is one thing. Doing it every day around work and family is another. We help with the doing, while your doctor leads your care.",
    forYou: ["You or a family member manage diabetes with a doctor", "You want simple, repeatable meal habits", "You'd value regular accountability"],
    support: ["Balanced plates using familiar home food", "Daily routine and activity habits", "Coaching that respects your medication and doctor's advice"],
  },
  {
    slug: "post-pregnancy-weight-loss",
    title: "Post-pregnancy wellness",
    short: "Gentle, realistic coaching for new mothers rebuilding energy and routine.",
    pillar: "Energise",
    image: "/images/cooking.jpg",
    alt: "Woman smiling while cooking a fresh meal at home",
    medical: false,
    intro: "Your body has done something extraordinary. We help you rebuild energy and healthy habits at a pace that respects that, once your doctor has given you the go-ahead.",
    forYou: ["You're a new mother ready to focus on yourself", "Sleep and time are in short supply", "You want gentle, realistic progress"],
    support: ["Simple nourishing meals for busy days", "Energy and routine coaching around your baby's schedule", "Encouraging check-ins with no judgement"],
  },
  {
    slug: "busy-professionals-wellness",
    title: "Energy for busy professionals",
    short: "Better meals, steadier energy and real routines for packed days.",
    pillar: "Energise",
    image: "/images/walk.jpg",
    alt: "Person walking on a sunlit path between trees",
    medical: false,
    intro: "Long hours, skipped meals and late dinners add up. We build routines that survive your calendar, not just your best weeks.",
    forYou: ["Your schedule decides what you eat", "Afternoon energy crashes are normal for you", "You want results without a complicated plan"],
    support: ["Meal planning that works around meetings and travel", "Small movement habits for desk-bound days", "Accountability that fits a busy phone"],
  },
];

export const FALLBACK_FAQS = [
  { question: "Who is this programme for?", answer: "Adults who want to lose weight steadily, feel more energetic or build healthier everyday habits. If you manage a medical condition, we offer nutrition support alongside your doctor's treatment." },
  { question: "What is the cost of the programme?", answer: "The Healthy Active Lifestyle Programme is ₹7,500 per month and runs for 120 days. Your first 20-minute consultation is free." },
];
